import { render } from "./AdminEvents.vue?vue&type=template&id=0376ef0e&scoped=true"
import script from "./AdminEvents.vue?vue&type=script&lang=js"
export * from "./AdminEvents.vue?vue&type=script&lang=js"

import "./AdminEvents.vue?vue&type=style&index=0&id=0376ef0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0376ef0e"]])

export default __exports__